import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {fuseAnimations} from '../../../../@fuse/animations';
import {OnDestroyMixin, untilComponentDestroyed} from '@w11k/ngx-componentdestroyed';
import {TranslateService} from '@ngx-translate/core';
import {Location} from '@angular/common';
import { Store} from '@ngrx/store';
import {AppState} from '@store/app.states';
import {CommonService} from '@app/components/_common/common.service';
import {environment} from '@environments/environment';
import {HttpClient} from '@angular/common/http';

@Component({
    selector: 'app-incidence-rate',
    templateUrl: './incidence-rate.component.html',
    styleUrls: ['./incidence-rate.component.scss'],
    animations: fuseAnimations,
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class IncidenceRateComponent extends OnDestroyMixin implements OnInit {

  @Input()
  pubUuid: string;

  isRefreshing = true;
  displayDetail = false;

  localData: {
    params: {
      extList,
      nbExtList,
      surveyIds,
    },
    stats: {
      passProfiling,
      response,
      valid,
      noQuality,
      incidenceRate,
    },

  } | {} = {};

  private BASE_URL = environment.apiUrl;

  constructor(
    private http: HttpClient,
    public translate: TranslateService,
    private location: Location,
    private cdr: ChangeDetectorRef,
    private store: Store<AppState>,
    private commonService: CommonService,
  ) {
    super();
  }

  getIncidence(pubUuid: string) {
    const url = `${this.BASE_URL}/4dm1n/actions`;
    return this.http.post<any>(url, {
      action: 'getDashboardIncidence',
      params: {
        pubUuid
      }
    });
  }


  ngOnInit(): void {

    this.getIncidence(this.pubUuid).pipe(
      untilComponentDestroyed(this),
    )
      .subscribe(
        (data) => {

          this.isRefreshing = false;
          this.localData = data.data.datas;

          console.log(this.localData);

          this.cdr.markForCheck();

        }
      );

  }

}
